{
  "approvals": {
    "title": "Dagen",
    "charactersShort": "tgn",
    "tooltips": {
      "openPreview": "Åpne forhåndsvisning",
      "openPlanning": "Åpne plan",
      "lastChanged": "Sist endret",
      "scheduledAt": "Planlagt kl"
    }
  },
  "plannings": {
    "label": {
      "plural": "Planer",
      "singular": "Plan"
    },
    "toasts": {
      "create": {
        "success": "Plan opprettet"
      },
      "openItem": "Åpne plan"
    }
  },
  "events": {
    "label": {
      "plural": "Hendelser",
      "singular": "Hendelse"
    },
    "columnLabels": {
      "startTime": "Starttid",
      "status": "Status",
      "organiser": "Arrangør",
      "section": "Kategori",
      "planningStatus": "Planstatus",
      "action": "Action"
    },
    "tooltips": {
      "organiser": "Arrangør"
    }
  },
  "assignments": {
    "title": "Oppdrag",
    "columnLabels": {
      "assignmentTime": "Oppdragstid",
      "type": "Oppdragstype"
    },
    "tooltips": {
      "assignmentStartTime": "Oppdragets starttid"
    },
    "actionMenu": {
      "openArticle": "Åpne artikkel",
      "openPlanning": "Åpne plan"
    },
    "myAssignments": "Mine oppdrag"
  },
  "factboxes": {
    "title": "Faktabokser",
    "columnLabels": {
      "description": "Beskrivelse",
      "lastChanged": "Sist endret",
      "origin": "Ursprung"
    },
    "origin": {
      "original": "Original",
      "inArticle": "Fra artikkel"
    }
  },
  "search": {
    "title": "Søk",
    "placeholders": {
      "search": "Søk"
    },
    "labels": {
      "plannings": "Plan",
      "events": "Hendelser",
      "articles": "Artikler"
    },
    "columnLabels": {
      "date": "Dato"
    }
  },
  "login": {
    "loginWith": "Logg inn med",
    "rememberMe": "Husk meg neste gang",
    "loggingIn": "Logger inn..."
  },
  "timeless": {
    "title": "Tidløse",
    "columnLabels": {
      "category": "Kategori",
      "lastChanged": "Sist endret",
      "actions": "Handlinger"
    },
    "toolbar": {
      "allCategories": "Alle kategorier"
    },
    "actions": {
      "new": "Ny tidløs",
      "openPlanning": "Åpne opprinnelig plan",
      "convertToArticle": "Planlegg som artikkel"
    },
    "placeholders": {
      "addCategory": "Legg til kategori"
    },
    "toasts": {
      "articlePlanned": "Artikkel planlagt",
      "timelessSaved": "Tidløs lagret",
      "conversionFailed": "Kunne ikke opprette det nye dokumentet: {{message}}",
      "notAuthenticated": "Kan ikke konvertere: ikke innlogget",
      "documentNotFound": "Dokumentet ble ikke funnet",
      "openArticle": "Åpne artikkel",
      "openTimeless": "Åpne tidløs",
      "openPlanning": "Åpne plan"
    }
  },
  "imageSearch": {
    "title": "Bilder",
    "labels": {
      "mediaType": "Medietype",
      "distributor": "Distributør",
      "allDistributors": "Alle distributører",
      "image": "Bild",
      "graphic": "Grafikk",
      "close": "Lukk",
      "searchFailed": "Bildesøk mislyktes",
      "retry": "Prøv igjen",
      "noResults": "Ingen resultater"
    }
  }
}
